// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"upload-image_wrapper__2PUGB","icon":"upload-image_icon__1GvA0","title":"upload-image_title__3IVc5"};